export const network = {
    chainId: '0x' + (97).toString(16), // 目标链ID
    chainName: 'BSC Testnet',
    nativeCurrency: {
        name: 'Testnet BNB',
        symbol: 'tBNB',
        decimals: 18
    },
    rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'], 
    blockExplorerUrls: ['https://bscscan.com']
}